var _circle, _path, _circle2, _path2, _circle3, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgWorkflow = function SvgWorkflow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 316,
    viewBox: "0 0 68 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#FBFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8505 21.3765C52.4898 22.0201 52.4863 23.06 51.8427 23.6993L29.1638 46.2266C28.1816 47.2022 26.5962 47.2021 25.614 46.2266L16.0524 36.7289C15.4088 36.0896 15.4053 35.0496 16.0446 34.406C16.6839 33.7624 17.7238 33.7589 18.3674 34.3982L27.3889 43.3594L49.5277 21.3687C50.1713 20.7294 51.2112 20.7329 51.8505 21.3765Z",
    fill: "#4BB970"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 158,
    r: 34,
    fill: "#FBFBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4971 140.754C45.4033 140.754 46.2553 141.103 46.8961 141.737L50.2541 145.061C51.577 146.37 51.577 148.501 50.2541 149.81L28.1613 171.677C27.7141 172.119 27.1679 172.439 26.566 172.612L20.9945 174.998C20.6096 175.163 20.2033 175.246 19.787 175.246C18.8066 175.246 17.8811 174.772 17.3112 173.977C16.7441 173.186 16.5993 172.165 16.9238 171.248L19.0299 165.292C19.1967 164.653 19.531 164.073 20.0052 163.604L35.346 148.42L40.5128 143.306L42.098 141.737C42.7389 141.103 43.5909 140.754 44.4971 140.754ZM21.3658 166.356L19.2834 172.286C19.1552 172.652 19.4407 172.998 19.787 172.998C19.8571 172.998 19.9297 172.984 20.0018 172.953L25.5737 170.55L21.3658 166.356ZM44.4971 143.245C44.2686 143.245 44.0401 143.332 43.8657 143.506L22.9216 164.382L27.5422 168.988L48.4864 148.112C48.8351 147.764 48.8351 147.201 48.4864 146.853L45.1284 143.506C44.9541 143.332 44.7256 143.245 44.4971 143.245Z",
    fill: "#424445"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 282,
    r: 34,
    fill: "#FBFBFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2174 283.642C20.1245 283.642 20.8599 282.907 20.8599 282C20.8599 281.093 20.1245 280.357 19.2174 280.357C18.3102 280.357 17.5749 281.093 17.5749 282C17.5749 282.907 18.3102 283.642 19.2174 283.642ZM19.2174 286.106C21.4852 286.106 23.3236 284.268 23.3236 282C23.3236 279.732 21.4852 277.894 19.2174 277.894C16.9495 277.894 15.1111 279.732 15.1111 282C15.1111 284.268 16.9495 286.106 19.2174 286.106Z",
    fill: "#424445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 283.642C34.9071 283.642 35.6425 282.907 35.6425 282C35.6425 281.093 34.9071 280.357 34 280.357C33.0928 280.357 32.3574 281.093 32.3574 282C32.3574 282.907 33.0928 283.642 34 283.642ZM34 286.106C36.2678 286.106 38.1062 284.268 38.1062 282C38.1062 279.732 36.2678 277.894 34 277.894C31.7321 277.894 29.8937 279.732 29.8937 282C29.8937 284.268 31.7321 286.106 34 286.106Z",
    fill: "#424445"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7825 283.642C49.6897 283.642 50.4251 282.907 50.4251 282C50.4251 281.093 49.6897 280.357 48.7825 280.357C47.8754 280.357 47.14 281.093 47.14 282C47.14 282.907 47.8754 283.642 48.7825 283.642ZM48.7825 286.106C51.0504 286.106 52.8888 284.268 52.8888 282C52.8888 279.732 51.0504 277.894 48.7825 277.894C46.5147 277.894 44.6763 279.732 44.6763 282C44.6763 284.268 46.5147 286.106 48.7825 286.106Z",
    fill: "#424445"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80V112",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 204V236",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWorkflow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/workflow.cfc05a3f36d344ce0d194e9fb4431234.svg";